import Liste from "@/domains/listes/liste";

// ---------------------------- ICI c'est le No Man's Land ----------------------------
// -----------------------------------------------------------------------------------

export default class Panier extends Liste {
}
